export default __webpack_public_path__ + "static/media/pic3.8ccf9fe9.jpg";